export default Object.freeze({
  reminders: {}
});
